import { supabaseClient } from '@/lib/supabase';

export async function deleteInjectionDetails(injectionId: string) {
	const { data, error } = await supabaseClient.from('injection_details').delete().eq('injection_id', injectionId);
	if (error) throw error;
	return data;
}
